// components/chiusure/Fioriere.tsx
import React, { useMemo } from "react";
import * as THREE from "three";
import { Edges } from "@react-three/drei";
import type { ElementCoordinateSystem } from "../common_types";
import { ConditionalAxesHelper } from "../Pergola";
import { Shape } from "three";
import { computeOrientation } from "../transformations";
import { sezionePilastro } from "../componeti/Pilastri";

type Sezione = { larghezza: number; altezza: number };

export const FiorieraCubo: React.FC<{
  id: string;
  sezione?: Sezione;
  lunghezza?: number;
  material: THREE.Texture;
  scarto?: number;
  cs: ElementCoordinateSystem;
}> = ({ id, cs, material, lunghezza = 0.45 }) => {
  const shape = useMemo(() => {
    const outer = new THREE.Shape([
      new THREE.Vector2(0.225, 0.225),
      new THREE.Vector2(0.225, -0.225),
      new THREE.Vector2(-0.225, -0.225),
      new THREE.Vector2(-0.225, 0.225),
    ]);

    const innerHole = new THREE.Path([
      new THREE.Vector2(0.2, 0.2),
      new THREE.Vector2(0.2, -0.2),
      new THREE.Vector2(-0.2, -0.2),
      new THREE.Vector2(-0.2, 0.2),
    ]);

    outer.holes = [innerHole];
    return outer;
  }, []);

  const isOnRightSide = id.includes("destra") || 
                        id.includes("H2") || 
                        id.includes("H3") || 
                        id.includes("Destra");

  const isOnLeftSide = id.includes("sinistra") || 
                       id.includes("H1") || 
                       id.includes("H4") || 
                       id.includes("Sinistra");

  const isOnBackSide = id.includes("retro") ||
                       id.includes("Retro");

  const isOnFrontSide = id.includes("fronte") ||
                       id.includes("Fronte");

  const offsetX = sezionePilastro.larghezza * 2 + 0.03;
  const offsetY = sezionePilastro.larghezza * 2 + 0.03;

  const finalX = cs.org.x + (
    isOnRightSide ? offsetX :
    isOnLeftSide ? -offsetX :
    0  
  );
  const finalY = cs.org.y + (
    isOnBackSide ? offsetY :
    isOnFrontSide ? -offsetY :
    0  
  );
  return (
    <mesh position={[finalX, finalY, 0]}>
      <extrudeGeometry args={[shape, { depth: lunghezza, bevelEnabled: false }]} />
      <meshStandardMaterial map={material} side={THREE.DoubleSide} />
      <Edges color="#363636" />
      <ConditionalAxesHelper />
    </mesh>
  );
};

export const FiorieraL: React.FC<{
  sezione?: Sezione;
  lunghezza?: number;
  material: THREE.Texture;
  scarto?: number;
  cs: ElementCoordinateSystem;
}> = (props) => {
  const shape = useMemo(() => {
    // Creiamo la forma esterna
    const outer = new THREE.Shape();
    outer.moveTo(0.408, 0.408);
    outer.lineTo(0.094, 0.408);
    outer.lineTo(0.094, 0.094);
    outer.lineTo(-0.22, 0.094);
    outer.lineTo(-0.22, -0.22);
    outer.lineTo(0.408, -0.22);
    outer.closePath();

    // Creiamo il buco interno
    const innerPath = new THREE.Path();
    innerPath.moveTo(0.358, 0.358);
    innerPath.lineTo(0.144, 0.358);
    innerPath.lineTo(0.144, 0.044);
    innerPath.lineTo(-0.17, 0.044);
    innerPath.lineTo(-0.17, -0.17);
    innerPath.lineTo(0.358, -0.17);
    innerPath.closePath();

    // AGGIUNGIAMO IL BUCO ALLA SHAPE
    outer.holes = outer.holes || []; // ← Questa riga risolve tutto
    outer.holes.push(innerPath);

    return outer;
  }, []);

  const rotation = computeOrientation(props.cs.direction) as [number, number, number];

  return (
    <group position={[props.cs.org.x, props.cs.org.y, props.cs.org.z]} rotation={rotation}>
      <mesh>
        <extrudeGeometry args={[shape, { depth: 0.6, bevelEnabled: false }]} />
        <meshStandardMaterial map={props.material} side={THREE.DoubleSide} />
        <Edges color="#363636" />
      </mesh>
      <ConditionalAxesHelper />
    </group>
  );
}